import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TosIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TosIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.5459 19.2224C12.1528 19.2229 11.7583 19.0979 11.4287 18.8464C11.3857 18.8245 11.3457 18.7952 11.3101 18.7595L2.14648 9.59594C1.95117 9.40063 1.95117 9.08422 2.14648 8.88891L6.11084 4.92407C6.30615 4.72876 6.62256 4.72876 6.81787 4.92407L8.75098 6.85669C9.75537 5.95532 11.3066 5.98804 12.271 6.9519C12.4663 7.14721 12.4663 7.46362 12.271 7.65893C12.0757 7.85424 11.7593 7.85424 11.564 7.65893C10.9556 7.05102 9.96583 7.05102 9.35743 7.65893L9.10255 7.9143C9.0088 8.00854 8.88136 8.06127 8.74903 8.06127C8.61622 8.06127 8.48877 8.00854 8.39502 7.91479L6.46436 5.98461L3.20704 9.24242L11.9478 17.9831C11.9649 17.9944 11.981 18.0066 11.9966 18.0203C12.3291 18.3064 12.8267 18.2898 13.1328 17.9831C13.439 17.677 13.4556 17.1785 13.1699 16.8469C12.999 16.6487 13.0103 16.3523 13.1953 16.1672C13.3818 15.9817 13.6924 15.9573 13.8892 16.1277C14.2212 16.4133 14.7193 16.3972 15.0254 16.0906C15.3316 15.7844 15.3482 15.2859 15.0625 14.9543C14.8916 14.7561 14.9028 14.4597 15.0879 14.2746C15.2739 14.0896 15.5855 14.0652 15.7818 14.2351C16.1138 14.5207 16.6123 14.5046 16.918 14.198C17.2241 13.8918 17.2407 13.3933 16.9551 13.0618C16.9414 13.0461 16.9292 13.03 16.918 13.0129L14.2691 10.364C14.0737 10.1687 14.0737 9.85227 14.2691 9.65696C14.4644 9.46165 14.7808 9.46165 14.9761 9.65696L17.625 12.3059C17.6563 12.3371 17.6846 12.3733 17.7085 12.4128L17.7129 12.4094C18.3379 13.135 18.2993 14.2312 17.625 14.905C17.2549 15.2756 16.7583 15.4592 16.2637 15.4363C16.2818 15.9299 16.103 16.4275 15.7324 16.7976C15.3628 17.1677 14.8584 17.3479 14.3711 17.3288C14.3892 17.8225 14.2105 18.3201 13.8399 18.6902C13.4868 19.0437 13.0171 19.2224 12.5459 19.2224Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7085 13.5334C17.5806 13.5334 17.4526 13.4846 17.355 13.387L14.1191 10.1516L13.2754 10.9954C12.3086 11.9622 10.6216 11.9631 9.65477 10.9954L9.02342 10.364C8.82811 10.1687 8.82811 9.85229 9.02342 9.65698L11.7285 6.9519C12.6933 5.98706 14.2446 5.95483 15.249 6.85669L17.1816 4.92407C17.3769 4.72876 17.6934 4.72876 17.8887 4.92407L21.8535 8.88891C21.9473 8.98266 22 9.10961 22 9.24243C22 9.37525 21.9473 9.5022 21.8535 9.59595L18.062 13.387C17.9643 13.4846 17.8364 13.5334 17.7085 13.5334ZM14.1191 8.94457C14.2471 8.94457 14.375 8.9934 14.4727 9.09105L17.7085 12.3264L20.793 9.24242L17.5352 5.98461L15.605 7.91479C15.4097 8.1101 15.0933 8.1101 14.8979 7.91479L14.6421 7.65893C14.0337 7.052 13.0439 7.052 12.4355 7.65893L10.084 10.0105L10.3618 10.2883C10.9512 10.8777 11.979 10.8787 12.5684 10.2883L13.7656 9.09105C13.8633 8.99339 13.9912 8.94457 14.1191 8.94457Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TosIcon;
